module.exports = __webpack_public_path__ + "static/img/img6.837b1aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img6.png
// module id = V0R5
// module chunks = 1